export class NotFoundException extends Error {
  data: any = undefined;

  constructor({ message = 'Not found exception', data = {} }: any) {
    super(message);

    this.data = data;
  }
}

export const validationMiddleware = () => (next: any) => (action: any) => {
  if (!action.error || !(action.payload instanceof Error) || (action.meta && action.meta.noValidation)) {
    return next(action);
  }

  if (action.payload.status === 404) {
    next(action);

    throw new NotFoundException({ data: action.payload.response });
  }

  return next(action);
};
